import React, { Component } from "react";
import { GlobalContext}  from "../../../../utils/globalprovider.js"

import Button from "../../../../components/bases/button/button.js";
import  imgDelete from "./assets/delete.png"
import  imgEdit from "./assets/edit.png"
import  imgView from "./assets/visu.png"
import  imgDupliquer from "./assets/dupliquer.png"
import  imgGraphe from "./assets/graphe.png"


import  imgSecVideo from "./assets/sections/video.png"
import  imgSecTr from "./assets/sections/tr.png"
import  imgSecSt from "./assets/sections/st.png"
import  imgSecVo from "./assets/sections/vo.png"
import  imgSecSeq from "./assets/sections/seq.png"
import  imgSecDoc from "./assets/sections/doc.png"

import "./assetsmanager.css"



class AssetSectionItem extends React.Component
{

  static contextType = GlobalContext;
  constructor(props) 
  {
    super(props);   
    this.onClick = this.onClick.bind(this)
    this.onClickOnAudio1 = this.onClickOnAudio1.bind(this)
    this.onClickOnAudio2 = this.onClickOnAudio2.bind(this)
    this.onClickOnCp = this.onClickOnCp.bind(this)
  }
  
  onClickOnAudio1(viid)
  {
    if (this.props.onClick) this.props.onClick(this.props.asset,"audio1");
  }
  onClickOnAudio2(viid)
  {
    if (this.props.onClick) this.props.onClick(this.props.asset,"audio2");

  }
  onClickOnCp(viid)
  {
    
    if (this.props.onClick) this.props.onClick(this.props.asset,"cp");
  }

  onClickOnTexts(viid)
  {
    if (this.props.onClick) this.props.onClick(this.props.asset,"texts");
  }


  onClick()
  {
    if (this.props.onClick !== null)
      this.props.onClick (this.props.asset)
  }

  renderProgressBar(pourcent,wpc)
  {
    return (
    
      <div className="assetpb1">
      <div className="assetpb2" style={{width:wpc.toString()+"%"}}><span>{pourcent.toString()+"%"}</span></div>
      </div>
    )

      
  }


  render()
  {

    var buttons = [];
    var buttonsfirst = [];


    if (this.props.mode ==="view")
    {
      buttons.push (
              <Button 
              button={true}
              image={imgView}
              tooltip={{"fr":"Visualiser","en":"View"}}
              disable={false}
              datas={this.props.asset}
              onClick={this.props.onView}
              height={12} width={12}/>)

      buttons.push (
              <Button 
              button={true}
              image={imgEdit}
              tooltip={{"fr":"Modifier","en":"Edit"}}
              disable={false}
              datas={this.props.asset}
              onClick={this.props.onEdit}
              height={12}  width={12}/>)
      
      buttons.push (
        <Button 
        button={true}
        image={imgDupliquer}
        tooltip={{"fr":"Dupliquer","en":"Duplicate"}}
        disable={(this.props.asset.astype === 3)}
        datas={this.props.asset}
        onClick={this.props.onDuplicate}
        height={12}  width={12}/>)
  
      buttons.push (
          <Button 
          button={true}
          image={imgDelete}
          tooltip={{"fr":"Supprimer","en":"Delete"}}
          disable={false}
          datas={this.props.asset}
          onClick={this.props.onDelete}
          height={12}  width={12}/>)

          
          buttons.push (
            <Button 
            button={true}
            image={imgGraphe}
            tooltip={{"fr":"Graphe des traitements","en":"Processes graph"}}
            disable={this.props.asset.astype != 3}
            datas={this.props.asset}
            onClick={this.props.onGraphe}
            height={12}  width={12}/>)
            
      }
      else
      {
        buttonsfirst.push(
          
            <Button 
            button={true}
            image={imgEdit}
            tooltip={{"fr":"Modifier le nom","en":"Edit Name"}}
            disable={false}
            datas={this.props.asset}
            onClick={this.props.onEdit}
            height={12}  width={12}/>)

            buttons.push (
              <Button 
              button={true}
              image={imgDupliquer}
              disable= {this.props.asset.astype === 3}
              tooltip={{"fr":"Dupliquer cet asset.","en":"Duplicate this asset."}}
              
              datas={this.props.asset}
              onClick={this.props.onDuplicate}
              height={12}  width={12}/>)
      
            if (!this.props.nodelete)
            {
              if (this.props.asset.astype !== 3) // video
              {
                if ((this.props.asset.asid !== this.props.selected.v1) && (this.props.asset.asid !== this.props.selected.v2))
                {

                  buttons.push (
                        <Button 
                        button={true}
                        image={imgDelete}
                        tooltip={{"fr":"Supprimer","en":"Delete"}}
                        disable={false}
                        datas={this.props.asset}
                        onClick={this.props.onDelete}
                        height={12}  width={12}/>)
                  }
              }
              else
              {
                if ((this.props.asset.asviid !== this.props.selected.v1) && (this.props.asset.asviid !== this.props.selected.v2))
                {
                  buttons.push (
                        <Button 
                        button={true}
                        image={imgDelete}
                        tooltip={{"fr":"Supprimer","en":"Delete"}}
                        disable={false}
                        datas={this.props.asset}
                        onClick={this.props.onDelete}
                        height={12}  width={12}/>)

                }
                
              }
            }
        

      }
      var parent = (<></>)
      if (this.props.parentasset !== null)
      {
        parent = (
          <div className="AssetSectionSubItem">
            {this.props.parentasset.asid}-{this.props.parentasset.astitle}
          </div>
        )
      }

    var id = this.props.asset.asid;

    const en = "Video shot changes";
    const fr = "Changements plan";
    const cptext = this.context.language=="fr"?fr:en;
    const textstext = this.context.language=="fr"?"Textes détectés":"Detected texts";

    const anatext = this.context.language=="fr"?"Analyse en cours":"Work in progess"
    var subitemsvideo = (<></>);
    if (this.props.asset.astype === 3)
    {
        // on affiche les audios
        // on cherche la video
        var ivideo = -1;
        for (var i=0; i < this.props.videolist.length; i++)
        {
          if (this.props.videolist[i].viid === this.props.asset.asviid)
          {
            ivideo = i;
            break;
          }
        }

        var codevideo =(<></>);
        
        if (ivideo !==-1)
        {
            codevideo = (<>{this.props.asset.asviid}&nbsp;</>)

            if (this.props.asset.asviid === this.props.selected.v1)
            {
              var bgcolor = this.props.selected.colorv1.backcolor;
              
              var forecolor = this.props.selected.colorv1.color;
              codevideo = (
                <><span 
                  style = {{color: forecolor, backgroundColor: bgcolor}}
                  className="assetSectionItemSelected">&nbsp;{this.props.asset.asviid}&nbsp;
                  </span>&nbsp;</>)
              
            }

            subitemsvideo = [];
            const video = this.props.videolist[ivideo];

            if (!video.finish)
            {
              var cupc = (video.pc / video.totalpc) * 100;
              cupc = Math.round(cupc)
              const wpc = Math.round((cupc * 95) / 100);
              subitemsvideo.push(
              <div className="AssetSectionSubItem">
                {anatext}{this.renderProgressBar(cupc, wpc)}
              </div>)

            }
            if (video.errorlib !=="")
            {
              subitemsvideo.push(
              <div className="AssetSectionSubItem">
              <span className="AssetSectionItemError">{video.errorlib}</span>
            </div>)
  

            }

            
            
            if (video.vixaudio === -3 )
            {
                if (video.vinbaudio > 0)
                {
                  subitemsvideo.push(
                  <div className="AssetSectionSubItemVideo" onClick = {this.onClickOnAudio1}>
                  Audio 1 <span className="AssetSectionItemVideoSpan">{video.viaudio1lang}</span>&nbsp;<span className="AssetSectionItemDateSpan">{video.viformataudio1}</span>&nbsp;<span className="AssetSectionItemDateSpan">{video.vicodecaudio1}</span>
                </div>)
      
                }
                if (video.vinbaudio > 1)
                {
                  subitemsvideo.push(
                  <div className="AssetSectionSubItemVideo" onClick = {this.onClickOnAudio2}>
                  Audio 2 <span className="AssetSectionItemVideoSpan">{video.viaudio2lang}</span>&nbsp;<span className="AssetSectionItemDateSpan">{video.viformataudio2}</span>&nbsp;<span className="AssetSectionItemDateSpan">{video.vicodecaudio2}</span>
                </div>)
      
                }
              } // fini ?

              if (video.vixcp === -3 )
              {
                  subitemsvideo.push(
                  <div className="AssetSectionSubItemVideo" onClick ={ e => {this.onClickOnCp(video.viid)}}>
                  {cptext} <span className="AssetSectionItemVideoSpan">{video.viorifile}</span>
                </div>)
        
              } // fini ?
    
              if (video.vixtex === -3 )
                {
                    subitemsvideo.push(
                    <div className="AssetSectionSubItemVideo" onClick ={ e => {this.onClickOnTexts(video.viid)}}>
                    {textstext} <span className="AssetSectionItemVideoSpan">{video.viorifile}</span>
                  </div>)
          
                } // fini ?
      
  
        }
    }
    
    
    
    var date = this.props.asset.asupdatedate;
    if (date.length != 10)
      date = "**/**/****";
    else
      date = date.substr(8,2)+ "/"+ date.substr(5,2)+"/"+ date.substr(0,4);

    
    if ((id === this.props.selected.v1) || (id === this.props.selected.v2))
    {

        
        var bgcolor = this.props.selected.colorv1.backcolor;
        var forecolor = this.props.selected.colorv1.color;
        if (id === this.props.selected.v2)
        {
          bgcolor = this.props.selected.colorv2.backcolor;
          forecolor = this.props.selected.colorv2.color;
        }
    

      id = (
      <span 
        style = {{color: forecolor, backgroundColor: bgcolor}}
        className="assetSectionItemSelected">&nbsp;{this.props.asset.asid}&nbsp;
        </span>)
    }

    var padding = 12;
    var paddingTop = 0;
    var itemtype=(<></>)
    
    if (this.props.tree)
    {
      padding = 6+ (this.props.deca) * 50 ;
      paddingTop = 4;
      

      switch (this.props.asset.astype)
      {
        case 1:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecTr} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Original transcription":"Transcription originale"}</span><br/></span><br></br></>
            );
            break;
        case 2:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecTr} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Corrected transcription":"Transcription corrigée"}</span><br/></span><br></br></>
            );
            break;
        case 3:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecVideo} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Video":"Vidéo"}</span><br/></span><br></br></>
            );
            break;
        case 4:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll" ><img src={imgSecSt} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Imported/Calculate subtitles":"Sous-titres calculés/Importés"}</span><br/></span><br></br></>
            );
            break;
        case 5:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecSt} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Corrected subtitles":"sous-titres corrigés"}</span><br/></span><br></br></>
            );
            break;
        case 6:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecTr} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Final transcription":"Transcription finale"}</span><br/></span><br></br></>
            );
            break;
        case 7:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecVo} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Voice over":"Voice over"}</span><br/></span><br></br></>
            );
            break;
        case 8:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecSeq} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Séquences":"Sequences"}</span><br/></span><br></br></>
            );
            break;
        case 9:
            itemtype =
            (
              <><span className="ASsetItemDisplayTypeAll"><img src={imgSecDoc} width={20} height={20} className="ASsetItemDisplayTypeImage"/>&nbsp;<span className="ASsetItemDisplayType">{this.context.language === "en"?"Documents":"Documents"}</span><br/></span><br></br></>
            );
            break;

      }

    }

    var subtype = (<></>)
    var origine = (<></>)
    var originevideo = [<></>]

    if (this.props.asset.asoriid > 0)
      origine = (<span className="AssetSectionItemDateSpan">{this.props.asset.asoriid}</span>)

    if ((this.props.asset.asviid > 0) && (this.props.asset !== 3))
      originevideo = (<span className="AssetSectionItemDateSpan">{this.props.asset.asviid}</span>)

    if ((this.props.asset.astype === 1) || (this.props.asset.astype === 2))
    {
      switch (this.props.asset.assubtype)
      {
        case 1:
          subtype = (<span className="AssetSectionItemDateSpan">{this.context.language==="fr"?"Simplifiée":"Simplified"}</span>)
          break;
        case 2:
          subtype = (<span className="AssetSectionItemDateSpan">{this.context.language==="fr"?"Scénario":"Scenario"}</span>)
          break;
      }
    }
    return(
        <div className="AssetSectionItem" style={{paddingTop:paddingTop, paddingLeft:padding}} >
          {itemtype}
          {buttonsfirst}
          {buttons}&nbsp;&nbsp;
          <span onClick={this.onClick}>{id}-{codevideo}{this.props.asset.astitle}</span>
          <div className="AssetSectionSubItem">
            <span className="AssetSectionItemDateSpan">{date}</span>&nbsp;<span className="AssetSectionItemDateSpan">{this.props.asset.aslang}</span>&nbsp;<span className="AssetSectionItemDateSpan">{this.props.asset.asext}</span>&nbsp;{subtype}&nbsp;{origine}&nbsp;{originevideo}
          </div>
          {subitemsvideo}
          {parent}
        </div>
    )



  }


}

AssetSectionItem.defaultProps = {
  parentasset: null,
  onClick: null,
  selected: 0,
  tree: false,
  concat: false,
}
export default AssetSectionItem;